export const IconLocationSimple = ({ style, className }) => {
  return (
    <svg
      style={style}
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M12 7.94C10.6911 7.94 9.63 9.00109 9.63 10.31C9.63 11.6189 10.6911 12.68 12 12.68C13.3089 12.68 14.37 11.6189 14.37 10.31C14.37 9.00109 13.3089 7.94 12 7.94ZM8.13 10.31C8.13 8.17266 9.86266 6.44 12 6.44C14.1373 6.44 15.87 8.17266 15.87 10.31C15.87 12.4473 14.1373 14.18 12 14.18C9.86266 14.18 8.13 12.4473 8.13 10.31Z"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M12.0032 2.75C8.58646 2.74769 5.2446 4.73032 4.35138 8.65591C3.29432 13.3261 6.18804 17.3762 8.91015 19.9997C10.6407 21.661 13.3606 21.659 15.0791 20.0004L15.0805 19.999C17.8124 17.3756 20.7056 13.3354 19.6485 8.6656L19.6485 8.66556C18.7599 4.73971 15.4201 2.75231 12.0032 2.75ZM21.1115 8.33441C20.04 3.60029 15.9848 1.25269 12.0042 1.25C8.02358 1.24731 3.96557 3.58953 2.88864 8.32364L2.88847 8.32441C1.64576 13.8139 5.07175 18.3836 7.8695 21.08L7.87045 21.0809C10.1798 23.2989 13.8191 23.3008 16.1204 21.08C18.9283 18.3834 22.3542 13.8239 21.1115 8.33441Z"/>
    </svg>
  );
};
